import {Injectable} from '@angular/core';
import {I18nPipe} from './services/i18n.pipe';
import {SweetUtil} from './components/commons/sweet/sweet-util-service';
import {AuthService} from './auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageTranslatorService {

  nonSpecialRequestErrors: Array<string> = ['mileage-not-plausible-at-day-of-delivery', 'nws-validation-error', 'mileage-delivery-date-validation'];

  constructor(private i18nPipe: I18nPipe, private sweetUtil: SweetUtil, private authService: AuthService) {
  }

  translateAndShowErrorMessageRequiringSpecialRequest(error, requiringSpecialRequest: boolean = true): void {
    const problem = this.i18nPipe.transform('', 'there-was-a-problem-submitting-this-warranty');
    const msgErr = this.getErrorMessageKey(error.error);
    const errorMessage = this.i18nPipe.transform('', msgErr);
    const sendInSpecialRequest = this.nonSpecialRequestErrors.includes(error.error) || !requiringSpecialRequest
    || this.authService.isAdmin() ? '' : this.i18nPipe.transform('', 'send-in-a-special-request') + '.';
    this.sweetUtil.showError(`${problem}. ${errorMessage} ${sendInSpecialRequest}`).then();
  }

  private getErrorMessageKey(error: string): string {
    const errorMessages: { [key: string]: string } = {
      'Unable to retrieve valid Mileage Factor!': 'send-in-a-special-request-a',
      'Unable to retrieve valid model code factor!': 'model-factor-error',
    };
    return errorMessages[error] || error;
  }

}
